import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import api from '../api';

Vue.use(Vuex);

import { settings } from './modules/settings.module';
import { projects } from './modules/projects.module';
import { biddings } from './modules/biddings.module';
import { tasks } from './modules/tasks.module';
import { users } from './modules/users.module';
import { profiles } from './modules/profiles.module';
import { talent } from './modules/talent.module';

export default new Vuex.Store({
    state: {
        status: '',
        token: localStorage.getItem('token') || '',
        user: {
            id: localStorage.getItem('id') || null,
        },
        loader: false,
        rates: [],
    },
    getters: {
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
        authToken: state => `Bearer ${state.token}`,
    },
    mutations: {
        setLoader(state, data) {
            state.loader = data;
        },
        make_request(state) {
            state.status = 'loading';
        },
        auth_success(state, data) {
            state.status = 'success';
            state.token = data.token;
            state.user.id = data.id;
        },
        request_success(state) {
            state.status = 'success';
        },
        request_error(state) {
            state.status = 'error';
        },
        logout(state) {
            state.status = '';
            state.token = '';
            state.user = {};
        },
    },
    actions: {
        signup({ commit }, user) {
            return new Promise((resolve, reject) => {
                commit('make_request');
                api({
                    url: '/signup',
                    data: user,
                    method: 'POST',
                })
                    .then(() => {
                        api({
                            url: '/login',
                            data: user,
                            method: 'POST',
                            withCredentials: true,
                            // header: { crossDomain: true, "Content-Type": "application/json" },
                        })
                            .then(resp => {
                                // console.log(resp.data);
                                const token = resp.data.split('=')[0] + '=';
                                const id = resp.data.split('=')[1];
                                // console.log("user_id: " + id);
                                localStorage.setItem('token', token);
                                localStorage.setItem('id', id);
                                // Add the following line:
                                // axios.defaults.headers.common["Authorization"] = token;
                                commit('auth_success', { token: token, id: id });
                                resolve(resp);
                            })
                            .catch(err => {
                                commit('request_error');
                                localStorage.removeItem('token');
                                reject(err);
                            });

                        /* const token = resp.data.split("=")[0] + "=";
            const id = resp.data.split("=")[1];
            localStorage.setItem("token", token);
            localStorage.setItem("id", id);
            commit("auth_success", { token: token, id: id });
            resolve(resp); */
                    })
                    .catch(err => {
                        // console.log(err);
                        commit('request_error', 'errxsss');
                        console.log('see this ' + 'errfdff');
                        localStorage.removeItem('token');
                        reject(err);
                    });
            });
        },

        login({ commit }, user) {
            // const config = {
            //   headers: { "Content-Type": "application/json" },
            //   withCredentials: true,
            // };
            return new Promise((resolve, reject) => {
                commit('make_request');
                api({
                    url: '/login',
                    data: user,
                    method: 'POST',
                    withCredentials: true,
                    // header: { crossDomain: true, "Content-Type": "application/json" },
                })
                    .then(resp => {
                        // console.log(resp.data);
                        const token = resp.data.split('=')[0] + '=';
                        const id = resp.data.split('=')[1];
                        // console.log("user_id: " + id);
                        localStorage.setItem('token', token);
                        localStorage.setItem('id', id);
                        // Add the following line:
                        // axios.defaults.headers.common["Authorization"] = token;
                        commit('auth_success', { token: token, id: id });
                        resolve(resp);
                    })
                    .catch(err => {
                        commit('request_error');
                        localStorage.removeItem('token');
                        reject(err);
                    });
            });
        },

        logout({ commit }) {
            commit('logout');
            localStorage.removeItem('token');
            localStorage.removeItem('id');
            delete axios.defaults.headers.common['Authorization'];
        },

        requestToken({ commit }, user) {
            return new Promise((resolve, reject) => {
                commit('make_request');
                //expects email field
                api({
                    url: '/token',
                    data: user,
                    method: 'POST',
                })
                    .then(resp => {
                        commit('request_success');
                        resolve(resp);
                    })
                    .catch(err => {
                        commit('request_error');
                        reject(err);
                    });
            });
        },

        verifyToken({ commit }, user) {
            return new Promise((resolve, reject) => {
                commit('make_request');
                //expects token field
                api({
                    url: '/verify',
                    data: user,
                    method: 'POST',
                })
                    .then(resp => {
                        commit('request_success');
                        resolve(resp);
                    })
                    .catch(err => {
                        commit('request_error');
                        reject(err);
                    });
            });
        },

        forgetPassword({ commit }, user) {
            return new Promise((resolve, reject) => {
                commit('make_request');
                //expects email field
                api({
                    url: '/forget',
                    data: user,
                    method: 'POST',
                })
                    .then(resp => {
                        commit('request_success');
                        resolve(resp);
                    })
                    .catch(err => {
                        commit('request_error');
                        reject(err);
                    });
            });
        },

        resetPassword({ commit }, user) {
            return new Promise((resolve, reject) => {
                commit('make_request');
                //expects resetToken and newPassword field
                api({
                    url: '/reset',
                    data: user,
                    method: 'POST',
                })
                    .then(resp => {
                        commit('request_success');
                        resolve(resp);
                    })
                    .catch(err => {
                        commit('request_error');
                        reject(err);
                    });
            });
        },
    },

    modules: {
        users,
        settings,
        projects,
        tasks,
        biddings,
        profiles,
        talent,
    },
});
